module.exports = __webpack_public_path__ + "img/GDL_1.ad469c4e.png";